module.exports = __webpack_public_path__ + "/build/web/images/fabrics/agde-17@2x.d02f8322f8e77c58ea68b84c0934854d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/fabrics/agde-17@2x.jpg
// module id = 131
// module chunks = 13